import React, { useState, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import axios from "axios";
import PostCard from "../components/Home/PostCard";
import "../styles/home.css";
import "../styles/profile.css";
import "../styles/explore.css";


export default function Explore() {
  // const {user} = useContext(UserContext)
  const user = { username: "nataliedeweerd" };
  const [posts, setPosts] = useState([]);

  useEffect(async () => {

    axios(`http://127.0.0.1:8000/api/semanticRecommender/${user.username}/`)
      .then((res) => {
        console.log(res.data.recommendations);
        setPosts(res.data.recommendations);
      })
      .catch((err) => {
        console.log(err);
      });


  }, []);

  const profile = false;

  return (
    <>
      <div className="profileGrid homeGrid explore">
        <h1>Explore</h1>

        <div className="rightProfile rightHome explore_r">
          {posts.map((post) => (
            <PostCard post={post} profile={profile} />
          ))}
         
        </div>
      </div>
    </>
  );
}
